import { isAdminTenant } from '@/models/role';

export const getFullName = (user) => {
  if (!user) return '';

  return user.firstName + ' ' + user.lastName;
};

const GROUPED_CONTENT = /\([^()]*\)|\[[^[\]]*\]|\{[^{}]*\}/g;
const UNCLOSED_GROUP = /[(\[{][^)\]}]*$/;

function stripGroupedContent(name) {
  let cleaned = String(name);
  let previous;
  do {
    previous = cleaned;
    cleaned = cleaned.replace(GROUPED_CONTENT, ' ');
  } while (cleaned !== previous);
  return cleaned.replace(UNCLOSED_GROUP, ' ').replace(/\s+/g, ' ').trim();
}

/** Initials from a display name. Ignores (), [] and {} content, then takes the first letter of each name part. */
export const getNameInitials = (name, maxLength = 3) => {
  if (!name) return '';

  const initials = stripGroupedContent(name)
    .split(/[\s-]+/)
    .filter(Boolean)
    .map((word) => {
      const letter = word.match(/\p{L}/u);
      return letter ? letter[0].toUpperCase() : '';
    })
    .join('');

  return initials.slice(0, maxLength);
};

// Who the current user may assign, as the assignation menus offer them: an admin anyone,
// others only users.
export const assignableUsers = (currentUser, users, usersOnly) =>
  (currentUser && isAdminTenant(currentUser.role) ? users : usersOnly) || [];
